import React, { MutableRefObject, useRef } from "react";
import { systemClass } from "../../../../lib/enums";
import backgrounds from "../../../../assets/images/buildings/backgrounds";
import { ConditionalWrapper } from "../../../Common/ConditionalWrapper";

interface IProps {
  tileTypeId: number;
  icon?: string;
  buttonText?: string;
  clickAction?: (ref?: MutableRefObject<any>) => void;
  disabled?: boolean;
}

const SlotPersonEmpty = ({
  tileTypeId,
  icon,
  buttonText,
  clickAction,
  disabled
}: IProps) => {
  const buttonRef = useRef(null);

  return (
    <div className="col-sm-3 col-md-2" style={{ paddingLeft: "2px", paddingRight: "2px" }}>
    <span className={`person empty dashed ${systemClass.MatchHeight} ${disabled ? "disabled" : ""}`}
          style={{ padding: "8px" }}>
      <h3 className="h3" style={{ margin: "0 0 8px" }}>
        {icon === "zamek" ? "Locked slot" : <>&nbsp;</>}
      </h3>
      <span className={"image"}>
        <ConditionalWrapper
          condition={!buttonText && !!clickAction}
          wrapper={(children: any) => (
            <a ref={buttonRef} onClick={() => clickAction && clickAction(buttonRef)}>
              {children}
            </a>
          )}
        >
          <img
            src={backgrounds[`background${tileTypeId}`]}
            alt="background"
            width={"142px"}
            height={"152px"}
            style={{ width: "100%", maxWidth: "unset", height: "auto" }}
          />
          {icon && <span className="info"><i className={`icon icon-${icon} icon-xlg middle`}/></span>}
          {buttonText
          && <a
            className={"btn btn-black"}
            ref={buttonRef}
            onClick={() => clickAction && clickAction(buttonRef)}
          >
            {buttonText}
          </a>}
        </ConditionalWrapper>
      </span>
      <div className={"text-left"}><i className="icon"/></div>
    </span>
    </div>
  )
}

export default SlotPersonEmpty;
